import './style.scss';

const Button = ({ className, ...props }) => (
  <button type="button" className={`app-btn ${className ?? ''}`} {...props}>
    {props.children || props.value}
  </button>
);

export default Button;
